// Left/right click-to-navigate zones overlaid on the product image gallery
// (see snippets/product-media-gallery.liquid .wrpg-gallery-nav buttons).
//
// On desktop (thumbnail layout, >= 750px) the product__media-list is NOT a
// horizontal-scroll slider - media-gallery.js manages active media via
// setActiveMedia(). On mobile the list IS a scroll-snap slider, so we fall
// back to the original scrollTo approach there.
//
// Both directions wrap around: next on the last image goes to the first,
// prev on the first image goes to the last.
(() => {
  // The script tag can end up on the page more than once; a second copy would
  // register every listener twice and advance two images per click.
  if (window.wrpgGalleryNavLoaded) return;
  window.wrpgGalleryNavLoaded = true;

  document.addEventListener("click", (event) => {
    const zone = event.target.closest(".wrpg-gallery-nav");
    if (!zone) return;

    const slider = zone.closest("slider-component");
    if (!slider) return;

    const track = slider.querySelector('[id^="Slider-"]');
    if (!track) return;

    const isPrev = zone.classList.contains("wrpg-gallery-nav--prev");

    // Desktop: delegate to media-gallery.js's setActiveMedia() which handles
    // the is-active class swap, thumbnail highlight and sticky-header avoidance.
    const mediaGallery = slider.closest("media-gallery");
    if (mediaGallery && typeof mediaGallery.setActiveMedia === "function") {
      // Direct children only: each slide also contains a lightbox toggle button
      // with its own data-media-id, which must not count as a slide.
      const slides = Array.from(track.querySelectorAll(":scope > [data-media-id]"));
      const currentIdx = slides.findIndex((s) => s.classList.contains("is-active"));
      if (currentIdx !== -1 && slides.length > 1) {
        const targetIdx = (currentIdx + (isPrev ? -1 : 1) + slides.length) % slides.length;
        mediaGallery.setActiveMedia(slides[targetIdx].dataset.mediaId);
        return;
      }
    }

    // Mobile fallback: scroll-snap track scrollTo (SliderComponent.sliderItemOffset
    // is set by initPages() when there are >= 2 visible items).
    const step = slider.sliderItemOffset || track.clientWidth || 0;
    if (!step) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    let left = track.scrollLeft + (isPrev ? -step : step);
    if (!isPrev && track.scrollLeft >= maxScroll - 2) left = 0;
    if (isPrev && track.scrollLeft <= 2) left = maxScroll;
    track.scrollTo({ left, behavior: "smooth" });
  });

  // Forward horizontal touch swipes from the transparent overlay zones 
  // to the underlying scroll track so mobile users can still swipe.
  let touchStartX = 0;
  let touchStartY = 0;
  let scrollStartX = 0;
  let activeTrack = null;
  let isSwiping = false;

  document.addEventListener("touchstart", (e) => {
    if (e.touches.length > 1) return;
    const zone = e.target.closest(".wrpg-gallery-nav");
    if (!zone) return;
    
    const slider = zone.closest("slider-component");
    if (!slider) return;
    
    activeTrack = slider.querySelector('[id^="Slider-"]');
    if (!activeTrack) return;

    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    scrollStartX = activeTrack.scrollLeft;
    isSwiping = false;
  }, { passive: true });

  document.addEventListener("touchmove", (e) => {
    if (!activeTrack) return;
    
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const diffX = touchStartX - currentX;
    const diffY = touchStartY - currentY;

    // Detect horizontal swipe vs vertical scroll
    if (!isSwiping) {
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 5) {
        isSwiping = true;
      } else if (Math.abs(diffY) > Math.abs(diffX) && Math.abs(diffY) > 5) {
        // Vertical scroll, let browser handle it, cancel our tracking
        activeTrack = null;
        return;
      }
    }

    if (isSwiping) {
      activeTrack.scrollLeft = scrollStartX + diffX;
      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false });

  const endTouch = () => {
    activeTrack = null;
    isSwiping = false;
  };
  
  document.addEventListener("touchend", endTouch);
  document.addEventListener("touchcancel", endTouch);
})();
